module.exports = "<div class=\"input-wrapper\">\r\n  <input type=\"number\" min=\"1\" [(ngModel)]=\"value\" (keyup.enter)=\"onEnter()\" value=\"value\" >\r\n  <div class=\"arrow-wrapper\">\r\n    <div class=\"arrow-up\" (click)=\"increase()\"></div>\r\n    <div class=\"arrow-down\" (click)=\"decrease()\"></div>\r\n  </div>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/app/shared/spinner/spinner.component.html
// module id = ../../../../../src/app/shared/spinner/spinner.component.html
// module chunks = main